export default __webpack_public_path__ + "static/media/banner.c43eafe7.png";